import { ChangeDetectorRef, Component, Input, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import SwiperCore, { Pagination, EffectFade, Autoplay } from 'swiper/core';

// Enable Swiper Paginate, Fade Effect and Autoplay

SwiperCore.use([Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-swiper-institutes-qualification',
    templateUrl: './swiper-institutes-qualification.component.html',
    styleUrls: ['./swiper-institutes-qualification.component.scss']
})
export class SwiperInstitutesQualificationComponent implements OnInit {

    // Collections

    partnerInstitutions: any = [];
    nationalQualifications: any = [];

    // Loaders

    loadedInstitutions: boolean = false;

    error: string = '';

    // A swiper config which is responsive and shows partial slides

    public responsivePartialOverflowConfig: any = {
        slidesPerView: 1.2,
        spaceBetween: 15,
        freeMode: true,
        watchOverflow: true, // Automatically hides pagination when not needed
        pagination: { clickable: true },
        breakpoints: {
            576: {
                slidesPerView: 2.1
            },
            768: {
                slidesPerView: 2.1
            },
            992: {
                slidesPerView: 2.1
            },
            1280: {
                slidesPerView: 3
            }
        }
    };

    constructor(
        private api: ApiService,
        private zone: NgZone,
        private router: Router,
        private cd: ChangeDetectorRef
    ) { }

    ngOnInit(): void {

        this.fetchInstitutions();

    }

    /**
     * Fetches all insitutions.
     * This is then split up into partner institutions and national qualifications
     */
    async fetchInstitutions() {

        await this.api.fetch_institutions('?orderBy=short_title')
            .subscribe(res => {
                res.data.items.forEach(element => {
                    element.description = JSON.parse(element.description);
                    element.short_description = JSON.parse(element.short_description);
                    if (element.type == 'PARTNER_INSTITUTE') {
                        this.partnerInstitutions.push(element);
                    } else {
                        this.nationalQualifications.push(element);
                    }
                });

                this.loadedInstitutions = true;
                this.cd.detectChanges();
            }, (err) => {
                this.error = 'An error has occurred. Unable to course catalogue. Please refresh.';
            });

    }

    /**
     * Navigate to selected institute
     * Accessed via National Qualification or Partner Institution
     * @param institution 
     */
    loadInstitute(institution) {

        this.zone.run(() => {
            this.router.navigate(['/institute/' + institution.identifier]);
        });

    }

    /**
     * When 'Partner Institutes' swiper is ready then run the update so that the slide size is correct
     * @param swiper 
     */
    onPartnerSwiper(swiper) {

        setTimeout(() => {
            // swiper.update();
        }, 1500);

    }

    /**
     * When 'National Qualification' swiper is ready then run the update so that the slide size is correct
     * @param swiper 
     */
    onNationalSwiper(swiper) {

        setTimeout(() => {
            //   swiper.update();
        }, 1500);

    }


}
